import {Directive, ElementRef, Renderer2} from "@angular/core";

@Directive({selector: '[userAgentCss]'})
export class UserAgentCssDirective {
    constructor(el: ElementRef, renderer: Renderer2) {
        const ua = window.navigator.userAgent;
        let uaCss = null;

        const msie = ua.indexOf('MSIE ');
        if (msie > 0 && uaCss == null) {
            // IE 10 or older => return version number
            uaCss = 'ie' + parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        const trident = ua.indexOf('Trident/');
        if (trident > 0 && uaCss == null) {
            // IE 11 => return version number
            let rv = ua.indexOf('rv:');
            uaCss = 'ie' + parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        const edge = ua.indexOf('Edge/');
        if (edge > 0 && uaCss == null) {
            // Edge (IE 12+) => return version number
            uaCss = 'edge';
        }

        const chrome = ua.indexOf('Chrome/');
        if (chrome > 0 && uaCss == null) {
            // Edge (IE 12+) => return version number
            uaCss = 'chrome';
        }

        const firefox = ua.indexOf('Firefox/');
        if (firefox > 0 && uaCss == null) {
            // Edge (IE 12+) => return version number
            uaCss = 'firefox';
        }

        if (uaCss == null) {
            uaCss = 'unknownBrowser';
        }

        renderer.addClass(el.nativeElement, uaCss);
        renderer.addClass(document.getElementsByTagName('body')[0], uaCss);
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-common-module/src/components/user-agent/user-agent-css.directive.ts